const priceClassDetails = (state = null, action) => {
  if (action.type === "SET_PRICE_CLASS_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_PRICE_CLASS_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default priceClassDetails;
